import { normalizeRoadPhysicalAddress } from './roadPhysicalAddress.mjs';

function normalizeNonNegativeInteger(value) {
  const normalized = Number(value);
  if (!Number.isFinite(normalized)) {
    return 0;
  }
  return Math.max(0, Math.trunc(normalized));
}

export function buildMachineRoadStructurePayload(rows) {
  const list = Array.isArray(rows) ? rows : [];
  return list.map((row) => ({
    maxstock: normalizeNonNegativeInteger(row.maxstock),
    number: row.number,
    is_froad: row.is_froad,
    maxbuy: Math.min(21, normalizeNonNegativeInteger(row.maxbuy)),
    ...(Object.prototype.hasOwnProperty.call(row, 'physics')
      ? { physics: normalizeRoadPhysicalAddress(row.physics) } : {}),
  }));
}

const MACHINE_ROAD_VALIDATION_KEYS = Object.freeze({
  invalid_mids: 'machineRoadInvalidMachines',
  invalid_detail: 'machineRoadInvalidDetail',
  invalid_row: 'machineRoadInvalidRow',
  invalid_number: 'machineRoadInvalidNumber',
  invalid_maxstock: 'machineRoadInvalidMaxstock',
  invalid_maxbuy: 'machineRoadInvalidMaxbuy',
  invalid_physics: 'machineRoadInvalidPhysics',
  duplicate_number: 'machineRoadDuplicateNumber',
  invalid_is_froad: 'machineRoadInvalidAuxiliary',
});

export function getMachineRoadValidationTranslation(data) {
  if (!data || data.error_code !== 'machine_road_validation') {
    return null;
  }
  const key = MACHINE_ROAD_VALIDATION_KEYS[data.reason]
    || MACHINE_ROAD_VALIDATION_KEYS.invalid_detail;
  return {
    key,
    params: {
      row: data.row,
      number: data.number,
      firstRow: data.first_row,
    },
  };
}
